module.exports = __webpack_public_path__ + "static/media/AOI_Icon_Dollar.94eb94b6.png";